import React, { useState, useEffect } from 'react';
import { useLocale } from '@edreamsodigeo/frontend-core';
import { FormSelector } from '@/components/FormField';
import { useCountries } from '@/hooks/GQL';
import { Spinner, Box } from '@edreamsodigeo/prisma-design-system';

export const CountrySelector = (props = {}) => {
  const [values, setValues] = useState(null);
  const locale = useLocale();
  const { data, loading } = useCountries({ locale });
  const { getCountries: { countries } = {} } = data || {};

  useEffect(() => {
    if (countries) {
      setValues(
        countries.map(({ phonePrefix, name } = {}) => [
          `${name} (${phonePrefix})`,
          phonePrefix,
        ])
      );
    }
  }, [countries]);

  const getDefaultValue = () => {
    if (countries) {
      return getBrowserDefaultCountry(countries)?.phonePrefix;
    }
  };

  return (
    <div data-testid="country-selector">
      {loading ? (
        <Box position="relative">
          <FormSelector values={[]} {...props} />
          <Box
            position="absolute"
            sx={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
          >
            <Spinner
              position="absolute"
              size="medium"
              data-testid="country-selector-spinner"
            />
          </Box>
        </Box>
      ) : (
        <FormSelector
          values={values || []}
          disabled={!values || values?.length === 0}
          defaultValue={getDefaultValue()}
          {...props}
        />
      )}
    </div>
  );
};

export function getBrowserDefaultCountry(countries = []) {
  if (navigator && (navigator.language || navigator.userLanguage)) {
    const locale = navigator.language
      .split('-')
      .slice(1)
      .map((item) => item.toUpperCase());

    return countries.find((country) =>
      locale.includes(country.code.toUpperCase())
    );
  }
}
